import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const ReturnButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <button className="button-return" onClick={() => navigate(-1)}>
      <i aria-hidden="true" className="icon icon-arrow-left pointer dark-icon"></i>
      {t("clubs.club.back")}
    </button>
  );
};

export default ReturnButton;
